/**
 * LiveVoiceSlot — la voix sur chaque vignette du live, et sur le bouton de mon micro (weekly du 03/11,
 * W1) : l'écran du tuteur et celui de l'élève posent ce fournisseur au-dessus de leur page, et chaque
 * vignette demande la voix de son participant (`VoiceSlotContext`). Seules les barres (`LiveVoice`) se
 * redessinent au rythme de la voix ; la page, jamais.
 */
import React, { type ReactNode } from "react"

import { VoiceSlotContext } from "../../../../../../design-system"
import { LiveVoice } from "./LiveVoice"

const renderVoice = (personId: string, size?: number) => <LiveVoice personId={personId} size={size} />

export function LiveVoiceSlot({ children }: { children: ReactNode }) {
    return <VoiceSlotContext.Provider value={renderVoice}>{children}</VoiceSlotContext.Provider>
}
